import {Component, Inject} from '@angular/core';
import {SuppliersService} from '../../../services/suppliers.service';
import {MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef} from '@angular/material/bottom-sheet';

@Component({
  selector: 'ps-pm-create-index',
  templateUrl: 'pm-create-index.component.html'
})
export class PmCreateIndexComponent {

  index: string;

  constructor(private suppliersService: SuppliersService, private bs: MatBottomSheetRef, @Inject(MAT_BOTTOM_SHEET_DATA) private data) {
  }

  save() {
    this.suppliersService.insertPmIndex(this.data.constructionId, this.index).subscribe(result => {
      this.bs.dismiss(result);
    });
  }

  cancel() {
    this.bs.dismiss();
  }
}
